import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DetailEmailLinkComponent, DetailPhoneLinkComponent, DetailViewModule } from '@ui/shared/ui-detail-view';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';

@Component({
    selector: 'ui-prevention-details-contact',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DetailViewModule, DetailEmailLinkComponent, DetailPhoneLinkComponent],
    templateUrl: './prevention-details-contact.component.html',
    styleUrls: ['./prevention-details-contact.component.scss'],
})
export class PreventionDetailsContactComponent {
    public mapItem = input.required<PreventionListItemModel>();
}
